module.exports = __webpack_public_path__ + "img/gestionMaritimeLogo.d9afe14d.jpg";